module.exports = __webpack_public_path__ + "img/e48.74ca29ee.png";